import { tags as t } from '@lezer/highlight'
import { createTheme } from '@uiw/codemirror-themes'
import colors from 'tailwindcss/colors'

// NOTE: I'm not 100% sure we need two themes here, but I don't see the harm
// in having them.

// TODO: (Tom Wells) On the off-chance this gets used to display or edit code, we will likely
// need to amend these styles. For now, since we're only displaying JSON, this is fine.

export const dittoLightTheme = createTheme({
  theme: 'light',
  settings: {
    background: 'hsl(var(--twc-background-surface))',
    foreground: 'black',
    caret: 'hsl(var(--twc-foreground-muted))',
    selection: colors.amber[200],
    selectionMatch: colors.amber[200],
    gutterBackground: 'hsl(var(--twc-background-surface))',
    gutterForeground: 'hsl(var(--twc-foreground-subtle))',
  },
  styles: [
    { tag: t.comment, color: 'hsl(var(--twc-fill-disabled))' },
    {
      tag: [t.variableName, t.number],
      color: 'hsl(var(--twc-fill-warning))',
    },
    {
      tag: [t.punctuation, t.separator, t.bracket, t.propertyName],
      color: 'black',
    },
    {
      tag: [
        t.string,
        t.special(t.brace),
        t.null,
        t.operator,
        t.className,
        t.definition(t.typeName),
        t.typeName,
        t.angleBracket,
        t.tagName,
        t.attributeName,
      ],
      color: 'hsl(var(--twc-fill-success))',
    },
    { tag: t.bool, color: 'hsl(var(--twc-fill-info))' },
    {
      tag: [t.keyword],
      color: 'hsl(var(--twc-fill-brand-primary))',
    },
    { tag: t.invalid, color: 'hsl(var(--twc-fill-error))' },
    { tag: [t.regexp, t.escape], color: 'hsl(var(--twc-fill-info))' },
  ],
})

export const dittoDarkTheme = createTheme({
  theme: 'dark',
  settings: {
    background: 'hsl(var(--twc-background-surface))',
    foreground: 'white',
    caret: 'hsl(var(--twc-foreground-muted))',
    selection: colors.amber[950],
    selectionMatch: colors.amber[950],
    gutterBackground: 'hsl(var(--twc-background-surface))',
    gutterForeground: 'hsl(var(--twc-foreground-subtle))',
  },
  styles: [
    { tag: t.comment, color: 'hsl(var(--twc-fill-disabled))' },
    {
      tag: [t.variableName, t.number],
      color: 'hsl(var(--twc-fill-warning))',
    },
    {
      tag: [t.punctuation, t.separator, t.bracket, t.propertyName],
      color: 'white',
    },
    {
      tag: [
        t.string,
        t.special(t.brace),
        t.null,
        t.operator,
        t.className,
        t.definition(t.typeName),
        t.typeName,
        t.angleBracket,
        t.tagName,
        t.attributeName,
      ],
      color: 'hsl(var(--twc-fill-success))',
    },
    { tag: t.bool, color: 'hsl(var(--twc-fill-info))' },
    {
      tag: [t.keyword],
      color: 'hsl(var(--twc-fill-brand-primary))',
    },
    { tag: t.invalid, color: 'hsl(var(--twc-fill-error))' },
    { tag: [t.regexp, t.escape], color: 'hsl(var(--twc-fill-info))' },
  ],
})
